<script setup lang="ts">
  import { computed, defineAsyncComponent } from 'vue'
  import { useApiRequestsAbort } from '@/shared/composables'
  import { TravelDirection } from '@/shared/types/common.types'
  import { useFeaturesStore } from '@/shared/store/featuresStore'

  const FlowTravelersWidget = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowTravelersWidget/FlowTravelersWidget.vue')
  )
  const FlowTravelersWidgetQC = defineAsyncComponent(
    () => import('@/widgets/Flow/FlowTravelersWidgetQC/FlowTravelersWidgetQC.vue')
  )

  const featuresStore = useFeaturesStore()
  const isTravelersQcEnabled = computed(() => featuresStore.isTravelersQcEnabled)
  useApiRequestsAbort()
</script>

<template>
  <FlowTravelersWidgetQC v-if="isTravelersQcEnabled" :type-of-travel="TravelDirection.INBOUND" />
  <FlowTravelersWidget v-else :type-of-travel="TravelDirection.INBOUND" />
</template>
